<main class="container-fluid">
    <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
      <section class="col-12 p-4 mb-5">
  
        <div class="d-flex justify-content-between">
          <div>
            <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
            <label class="h5">Ajustes RNT</label>
          </div>
          <p>
            <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
              Ver filtros
            </button>
          </p>
        </div>
        <div id="filtros" [ngbCollapse]="isCollapsed">
            <div class="card mb-3">
              <div class="card-body">
                <form [formGroup]="filtro" (submit)="filtrar()">
                  <div class="row">
                    <div class="col-2 form-group">
                      <label class="small text-secondary" for="numero_rnt">Número RNT</label>
                      <input id="numero_rnt" formControlName="numero_rnt" type="text"
                        class="form-control form-control-sm">
                    </div>
                  </div>
                  <div class="row">
                    <div class="d-flex flex-row">
                        <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                          (click)="limpiar()">Limpiar</button>
                        <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical"
                          type="submit">Filtrar</button>
                      </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
    
        <form [formGroup]="formUpdate">
            <ng-container formArrayName="solicitudes">
                <div class="table-responsive">
                    <app-tablas [page]="paginaActual" [headers]="headerTabla" [sizeData]="dataTabla.paging.totalItems"
                        (paginado)="onPaginado($event)" class="table-responsive">
                                <ng-container *ngFor="let solicitud of formUpdate.controls.solicitudes?.value; let i = index">
                                    <tr [formGroupName]="i" class="small">
                                        <td>{{ solicitud.codigo_rnt }}</td>
                                        <td>{{ solicitud.tipo_rnt }}</td>
                                        <td>{{ solicitud.solicitud_id }}</td>
                                        <td>{{ solicitud.formulario }}</td>
                                        <td>{{ solicitud.fecha_radicacion }}</td>
                                        <td>
                                            <select id="estado_solicitud_id" formControlName="estado_solicitud_id" class="form-control small">
                                                <ng-container *ngFor="let estadoSolicitud of estadoSolicitudLista">
                                                    <option [value]="estadoSolicitud.estado_solicitud_id">
                                                    {{ estadoSolicitud.descripcion }}
                                                    </option>
                                                </ng-container>
                                            </select>
                                        </td>
                                        <td>{{ solicitud.razon_social }}</td>
                                        <td>{{ solicitud.matricula }}</td>
                                        <td>{{ solicitud.nit }}</td>
                                        <td>{{ solicitud.numero_radicacion }}</td>
                                        <td>
                                            <select id="estado_rnt_id" formControlName="estado_rnt_id" class="form-control small">
                                                <ng-container *ngFor="let estado of estadoRnt">
                                                    <option [value]="estado.estado_rnt_id">
                                                    {{ estado.descripcion }}
                                                    </option>
                                                </ng-container>
                                            </select>
                                        </td>
                                        <td>
                                          <input type="checkbox" formControlName="activo"/>
                                        </td>
                                        <td>{{ solicitud.fecha_inicio_suspension }}</td>
                                        <td>
                                            <input type="datetime-local" formControlName="fecha_fin_suspension" class="form-control"  />
                                        </td>
                                        <td>
                                          <input type="number" formControlName="nuevo_rnt_id" class="form-control"  />
                                        <td>{{ solicitud.fecha_creacion }}</td>
                                        <td>{{ solicitud.usuario_creacion }}</td>
                                        <td>
                                            <input type="datetime-local" formControlName="fecha_ultima_actualizacion" class="form-control"  />
                                        </td>
                                        <td>
                                            <button class="w-100 btn btn-primary" (click)="changeUser(i)">
                                                {{ solicitud.usuario_ultima_actualizacion }}
                                            </button>
                                            
                                        </td>
                                    </tr>
                                </ng-container>
                    </app-tablas>
                </div>
            </ng-container>
            
        </form>
        <div class="row mt-4">
            <div class="col-12 text-right">
                <button class="btn btn-primary" 
                        (click)="onUpdateRnt()"
                        [disabled]="indexDirty.length === 0">
                    Guardar
                </button>
            </div>
        </div>
      </section>
    </article>
  </main>